import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function PrivateRoute({ children, requireVerified = true }) {
  const { currentUser } = useAuth();
  const location = useLocation();

  // Check if user is authenticated
  if (!currentUser) {
    // Save the intended destination for redirect after login
    const redirectUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/signin?redirect=${redirectUrl}`} replace />;
  }

  // Check if user needs to be verified for this route
  if (requireVerified && !currentUser.isVerified) {
    // Pass the user's email and current route for redirect after verification
    const redirectUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/verify-email?email=${encodeURIComponent(currentUser.email)}&redirect=${redirectUrl}`} replace />;
  }

  // User passes all checks, render the protected component
  return children;
}

export default PrivateRoute; 